"use client";

import { useSyncExternalStore } from "react";
import { formatStamp } from "@softmax/product-ux/play-values";

const subscribe = () => () => {};
const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const serverTimeZone = () => "UTC";

export function PlayLocalTime({
  iso,
  now,
  dayOnly = false,
  timeOnly = false,
  className,
}: {
  readonly iso: string | null;
  readonly now: string;
  readonly dayOnly?: boolean;
  readonly timeOnly?: boolean;
  readonly className?: string;
}) {
  const timeZone = useSyncExternalStore(
    subscribe,
    browserTimeZone,
    serverTimeZone,
  );
  return (
    <time dateTime={iso ?? undefined} className={className}>
      {formatStamp({
        iso,
        now: new Date(now),
        opts: { dayOnly, timeOnly, timeZone },
      })}
    </time>
  );
}
